import { ColumnList } from 'components/ColumnList';
import { ColumnListColumn } from 'components/ColumnList/types';

import { DisplayPrices, Order } from '../types';

const columns: ColumnListColumn[] = [
  { header: '', accessor: 'name', align: 'left', flex: 9 },
  { header: '', accessor: 'localAmount', align: 'right', flex: 1 }
];

export const TaxDetails = ({
  order,
  displayPrices
}: {
  order?: Order;
  displayPrices: DisplayPrices | null;
}) => {
  if (!order || !displayPrices) return null;
  return (
    <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
      <h2 className="font-medium text-xl text-base-primary">Tax</h2>
      <div className="flex flex-col gap-4">
        <ColumnList
          columns={columns}
          data={[
            {
              name: 'Estimated Fee Amount',
              localAmount:
                displayPrices.estimatedAppchargeFee != null
                  ? `$${displayPrices.estimatedAppchargeFee}`
                  : 'N/A',
              localAmountDataTestId: 'taxDetailsEstimatedFeeAmount'
            },
            {
              name: 'Estimated Net Revenue',
              localAmount:
                displayPrices.estimatedPublisherNetAmount != null
                  ? `$${displayPrices.estimatedPublisherNetAmount}`
                  : 'N/A',
              localAmountDataTestId: 'taxDetailsEstimatedNetRevenue'
            }
          ]}
        />
      </div>
    </div>
  );
};
